<script>
import ContentConfig from '@/views/project-task/setting/components/ContentConfig.vue'
import settingMixin from '@/views/project-task/setting/mixins/setting-mixin'
export default {
  name: 'Auditor',
  components: { ContentConfig },
  mixins:[settingMixin],
  data() {
    return {

    }
  },
  computed:{
    projectId: ({ $route }) => $route.params.id,
    briefType: ()=>1,
  },
  methods: {

  },
}
</script>

<template>
  <div class="p-4 h-full box-border" v-loading="loading">
    <template v-if="!loading">
      <template v-if="enabledConfig">
        <div class="base-box">
          <div class="title">审核员任务书</div>
          <div class="content form-content">
            <div class="form-item">
              <span class="label">启动审核员任务书</span>
              <el-switch v-model="model.active" />
            </div>
          </div>
        </div>
        <div class="base-box">
          <div class="title">任务书签署配置</div>
          <div class="content form-content">
            <div class="form-item">
              <span class="value">手写签名</span>
              <el-checkbox v-model="model.showSignToInvestigator">
                <span class="label">审核员端需显示</span>
              </el-checkbox>
            </div>
            <div class="form-item">
              <span class="value">姓名、身份证号、手机号</span>
              <el-checkbox v-model="model.showUserInfoToInvestigator">
                <span class="label">审核员端需显示（回显已实名信息）</span>
              </el-checkbox>
            </div>
            <div class="form-item">
              <span class="value">身份证人像面照片、身份证国徽面照片</span>
              <el-checkbox v-model="model.showIdCardPhotoToInvestigator">
                <span class="label">审核员端需显示（回显已实名信息）</span>
              </el-checkbox>
            </div>
            <div class="form-item">
              <span class="value">无犯罪记录证明</span>
              <el-checkbox v-model="model.showNoCriminalToInvestigator">
                <span class="label">审核员端需显示</span>
              </el-checkbox>
            </div>
          </div>
        </div>
        <div class="base-box">
          <div class="title">审核员任务书内容配置</div>
          <ContentConfig
            :type="briefType"
            :project-id="projectId"
            :title.sync="model.briefTitle"
            :content.sync="model.briefContent"
          />
        </div>
      </template>
      <template v-else>
        <div class=" initial">
          <div class="text-center">
            <div class="text-theme-black-850 font-bold mb-3 text-large-x"><span>项目任务书</span></div>
            <div class="text-theme-black-650 text-medium leading-22">
              <div><span>开启项目任务书，设置任务书内容后</span></div>
              <div><span>关联项目的审核员需要签署任务书后，才能承接相关项目</span></div>
            </div>
            <div class="mt-6">
              <el-button type="primary" :loading="enableLoading" @click="openTask">开启任务书</el-button>
            </div>
          </div>
          <div class="text-center mt-8">
            <img src="~@/assets/img/project-task/introduction.png" width="894">
          </div>
        </div>
      </template>
    </template>
  </div>
</template>

<style scoped lang="scss">
.base-box {
  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.06);
  border-radius: 2px;
  padding: 24px;
  background: #FFF;
  margin-bottom: 16px;

  &:last-child {
    margin-bottom: 0;
  }

  .title {
    font-weight: 600;
    font-size: 16px;
    color: rgba(0, 0, 0, 0.85);
    line-height: 20px;
    margin-bottom: 16px;
  }

  .form-content {
    .form-item {
      display: flex;
      align-items: center;
      margin-bottom: 12px;

      &:last-child {
        margin-bottom: 0;
      }
    }

    .label {
      font-weight: 400;
      font-size: 14px;
      color: rgba(0, 0, 0, 0.85);
      margin-right: 24px;
    }

    .value {
      font-weight: 400;
      font-size: 14px;
      color: rgba(0, 0, 0, 0.45);
      margin-right: 24px;
    }
  }
}
.initial {
  min-height: 100%;
  background: #FFF;
  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.06);
  border-radius: 2px;
  padding: 56px 0;
  box-sizing: border-box;
}
</style>
